var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"my-2",attrs:{"color":"secondary white--text","dense":"","depressed":"","rounded":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }